import React, { useState, useEffect } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import toast, { Toaster } from "react-hot-toast"
import ReactPaginate from "react-paginate"
import { addData } from "Servicescalls"
import { imgUrl } from "Baseurls"

const Eventgallery = () => {
  const [modal_small, setmodal_small] = useState(false)

  function tog_small() {
    setmodal_small(!modal_small)
    removeBodyCss()
  }

  const [Files, setFiles] = useState({ profile_pic: "" })

  const changeHandler = e => {
    const file = e.target.files
    var ext = file[0].name.split(".").pop()
    var type = ext
    if (
      type == "jpg" ||
      type == "jpeg" ||
      type == "png" ||
      type == "JPG" ||
      type == "JPEG" ||
      type == "PNG"
    ) {
      setFiles(e.target.files)
    } else {
      e.target.value = null
      toast.error("Please select a valid image file (jpg, jpeg, or png)")
    }
  }

  const [User, setUser] = useState([])
  const [form, setform] = useState([])

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }

  const GetAll = async () => {
    const resonse = await addData("password-request/list")
    var _data = resonse
    setUser(_data.data.data)
  }

  const Add = async () => {
    const formid = form._id
    const bodydata = {
      userId: formid,
      password: form.password,
    }

    try {
      const resonse = await addData(
        "password-request/change-password",
        bodydata
      )
      var _data = resonse
      setform(
        {
          password: "",
        },
        setFiles({
          profile_pic: "",
        })
      )
      toast.success(_data.data.message)
      setmodal_small(false)
      GetAll()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }
  }

  const getpopup = data => {
    setform(data)
    tog_small()
  }

  const handleSubmit = e => {
    e.preventDefault()
    Add()
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = User.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(User.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  useEffect(() => {
    GetAll()
  }, [])

  const [search, setsearch] = useState([])

  const searchAll = async e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)
    const resonse = await addData(
      "password-request/list?searchQuery=" + e.target.value
    )
    var _data = resonse
    setUser(_data.data.data)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Hasini Enterprises"
            breadcrumbItem="Requested Password"
          />
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md="6"></Col>
                    <Col md="6">
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          className="form-control"
                          placeholder="Search.."
                          value={search.search}
                          onChange={searchAll}
                          name="search"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div>
                    <div className="table-responsive">
                      <Table className="table table-bordered mb-4 mt-3">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Profile</th>
                            <th>Salary</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.length == 0 ? (
                            <tr>
                              <td className="text-center" colSpan="10">
                                <h5>No Data...</h5>{" "}
                              </td>
                            </tr>
                          ) : (
                            <>
                              {lists.map((data, key) => (
                                <tr key={key}>
                                  <td>{(pageNumber - 1) * 5 + key + 6}</td>
                                  <td>{data?.user?.firstname} </td>
                                  <td>{data?.user?.email}</td>
                                  <td>{data?.user?.phone} </td>
                                  <td>
                                    <img
                                      style={{ width: "70px" }}
                                      src={imgUrl + data?.user?.profile_pic}
                                    />
                                  </td>
                                  <td>₹ {data?.user?.salary}</td>
                                  <td
                                    className={
                                      data?.user?.status == "active"
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {data?.user?.status}
                                  </td>
                                  <td>
                                    <Button
                                      onClick={() => {
                                        getpopup(data?.user)
                                      }}
                                      className="mr-2"
                                      style={{ padding: "6px", margin: "3px" }}
                                      color="success"
                                      outline
                                    >
                                      <i className="bx bx-edit"></i>
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </Table>
                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          centered
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Delivery Boy
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit(e)
              }}
            >
              <Row>
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Name: {form.firstname}
                    </Label>
                  </div>
                </Col>

                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Phone No: {form.phone}
                    </Label>
                  </div>
                </Col>
                <Col md="12">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Password</Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Password"
                      required
                      name="password"
                      value={form.password}
                      onChange={e => {
                        handleChange(e)
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <div style={{ float: "right" }}>
                <Button
                  onClick={() => {
                    setmodal_small(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="success" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>

        <Toaster />
      </div>
    </React.Fragment>
  )
}

export default Eventgallery
